import React from "react";
import classnames from "classnames";
import GoToPage from "./goToPage";
const Tile = (props) => {
  const { icon, title, buttonText, page, target } = props;
  const styles = classnames(props.bgColor);
  return (
    <div className="lg:px-0 md:px-0 sm:px-10 px-10 h-full lg:py-0 md:pt-0 sm:pt-5 pt-5">
      <div className={styles}>
        <div className="grid grid-cols-1 2xl:h-[22rem] xl:h-[22rem] lg:h-[22rem] md:h-[22rem]  sm:h-[22rem] h-[20rem] relative lg:mb-10 md:mb-10 sm:mb-5 mb-5">
          <div className="flex lg:justify-start md:justify-start sm:justify-center justify-center lg:absolute md:absolute sm:relative relative top-0">
            <img loading="lazy"
              src={icon}
              className="mt-10 ml-5 lg:w-20 md:w-20 sm:w-20 w-14 "
            ></img>
          </div>
          <div className="mb-10 pl-10  lg:absolute md:absolute sm:relative relative bottom-0">
           
              {title}
            
            <div className="flex lg:justify-start md:justify-start sm:justify-center justify-center mr-10">
              <GoToPage
                page={page}
                target={target}
                side="right"
                name={buttonText}
                fontSizeXL="xl:text-2xl"
                fontSizeL="lg:text-base"
                fontSizeM="md:text-base"
                fontSizeS="sm:text-base"
                fontSize="text-base"
                textType="font-bold"
                textColor="text-white"
                borderType="border-b-2"
                borderColor="border-white"
                iconSize="h-6"
                iconColor="invert"
                iconMargin="ml-5"
              ></GoToPage>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tile;
